import CloseIcon from "assets/icons/close.svg?react";
import Button from "components/Button";
import HollowButton from "components/HollowButton";
import Input from "components/Input";
import { IStatus } from "dto/IStatus";
import { ITag, TagType } from "dto/ITag";
import { useEffect, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import tagsService from "api/tagsService";
import statusService from "api/statusService";
import ChooseTagNewFilter from "components/ChooseTagNewFilter";
import SelectFlagNewFilter from "components/SelectFlagNewFilter";
import StatusBadge from "components/StatusBadge";
import Chip from "components/Chip";
import dossierService, { ICreateFilterRequest } from "api/dossierService";
import SidebarDossierFilterChooseCategory from "components/SidebarDossierFilterChooseCategory";
import { DossierItemCategory } from "dto/Dossier/DossierItemCategory";
import { getDossierItemCategoryLabel } from "utils/getDossierItemCategoryLabel";
import { ListType } from "dto/ListType";
import SidebarDossierFilterChoosePerson from "components/SidebarDossierFilterChoosePerson";
import { IUserInfo } from "dto/IUserInfo";
import UserBadge from "components/UserBadge";
import { useTranslation } from "react-i18next";

export const SidebarDossierFilterModal: FC<Props> = ({
  listType,
  listRef,
  toggle,
  getFilters,
  initialValues,
}) => {
  const { t } = useTranslation();
  const { data: tagsData } = tagsService.useGetTags(false, TagType.Dossier);
  const { data: statusesData } = statusService.useGetStatuses();

  // const { data: possibleSharedTo } = dossierService.useGetPossibleSharedTo(
  //   listType === ListType.Shares
  // );
  // const { data: possibleSharedBy } = dossierService.useGetPossibleSharedBy(
  //   listType === ListType.Shares
  // );

  const tagd = useMemo(() => tagsData?.data ?? [], [tagsData]);
  const statused = useMemo(() => statusesData?.data ?? [], [statusesData]);

  const [position, setPosition] = useState([0, 0]);
  const [showed, setShowed] = useState("none");
  const [name, setName] = useState("");

  const [category, setCategory] = useState<DossierItemCategory | null>(null);
  const [tags, setTags] = useState<ITag[]>([]);
  const [statuses, setStatuses] = useState<IStatus[]>([]);

  const [sharedBy, setSharedBy] = useState<IUserInfo | null>(null);
  const [sharedTo, setSharedTo] = useState<IUserInfo | null>(null);

  const { mutate: createFilter } = dossierService.useCreateFilter();
  // const { mutate: deleteFilter } = dossierService.useDeleteFilter();

  useEffect(() => {
    setName(initialValues?.Name ?? "");
    setCategory(initialValues?.Category ?? null);

    if (initialValues?.TagIds) {
      const findedTags = tagd?.filter((tag: ITag) =>
        initialValues?.TagIds?.find((iTag) => tag.Id === iTag)
      );
      setTags(findedTags ?? []);
    }

    if (initialValues?.StatusIds) {
      const findedStatuses = statused?.filter((status: IStatus) =>
        initialValues?.StatusIds?.find((iStatus) => status.Id === iStatus)
      );

      setStatuses(findedStatuses);
    }

    // if (initialValues?.SharedByUserId) {
    //   const usr = possibleSharedBy?.data.filter(
    //     (u: IUserInfo) => u.Id === initialValues.SharedByUserId
    //   );
    //   if (usr) {
    //     setSharedBy(usr.length > 0 ? usr[0] : null);
    //   }
    // }

    // if (initialValues?.SharedToUserId) {
    //   const usr = possibleSharedTo?.data.filter(
    //     (u: IUserInfo) => u.Id === initialValues.SharedToUserId
    //   );
    //   if (usr) {
    //     setSharedTo(usr.length > 0 ? usr[0] : null);
    //   }
    // }
  }, [
    initialValues,
    tagd,
    // possibleSharedBy,

    // possibleSharedTo
  ]);

  const handleChooseTag = (tag: ITag | null) => setTags([...tags, tag!]);
  const handleRemoveTag = (removeTag: ITag) =>
    setTags(tags.filter((tag) => tag.Id !== removeTag.Id));
  const handleChooseStatus = (status: IStatus) =>
    setStatuses([...statuses, status]);

  const handleDelete = () => {
    if (initialValues && initialValues.Id) {
      deleteFilter({ Id: initialValues.Id });
    }

    setTimeout(() => {
      getFilters(listType);
    }, 50);
    toggle(false);
  };

  const handleCreate = () => {
    const data: ICreateFilterRequest = {
      Id: initialValues?.Id ? initialValues.Id : undefined,
      Name: name,
      ListType: listType,

      TagIds: tags.map((tag) => tag.Id),
      StatusIds: statuses?.map((a) => a.Id) ?? [],

      Category: category,

      SharedByUserId: sharedBy?.Id,
      SharedToUserId: sharedTo?.Id,
    };

    createFilter(data, {
      onSuccess: () => {
        getFilters(listType);
        toggle(false);
      },
    });
  };

  useEffect(() => {
    if (listRef.current) {
      const left = listRef.current.offsetLeft + listRef.current.offsetWidth;
      const top = listRef.current.offsetTop + listRef.current.offsetHeight / 2;

      setPosition([left, top]);
      setShowed("block");
    }
  }, [listRef]);

  return (
    <div
      style={{ left: position[0], top: position[1], display: showed }}
      className={styles.modal}
    >
      {/* <i className={classNames(styles.arrow, styles.left)}></i> */}
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.title}>
            {initialValues ? t("common.list") : t("sidebar.newList")}
          </div>
          <div onClick={() => toggle(false)} className={styles.close}>
            <CloseIcon className={styles.closeButton} />
          </div>
        </div>
        <Input
          value={name}
          placeholder={t("sidebar.enterNewFilterName")}
          onChange={(text) => setName(text)}
          label={t("common.name")}
        />

        <div className={styles.types}>
          {/* {!!types.length && (
            <>
              <div className={styles.typesHeader}>Rodzaje przesyłek</div>
              <div className={styles.typesList}>
                {types.map((type) => (
                  <div className={styles.box}>
                    <div className={styles.typeName}>{type.name}</div>
                    <div className={styles.typeCheckbox}>
                      <SecondCheckbox
                        value={type.active}
                        onChange={(state) =>
                          handleChangeState(type.name, state)
                        }
                      />
                    </div>
                  </div>
                ))}
              </div>
            </>
          )} */}

          <div className={styles.options}>
            <SidebarDossierFilterChooseCategory
              types={[
                DossierItemCategory.Documents,
                DossierItemCategory.Images,
                DossierItemCategory.Presentations,
                DossierItemCategory.Workbooks,
                DossierItemCategory.Link,
                DossierItemCategory.Other,
              ]}
              onChoose={(c) => {
                setCategory(c);
              }}
            />
            <ChooseTagNewFilter
              className={styles.choose}
              onChoose={handleChooseTag}
            />
            <SelectFlagNewFilter
              selectedStatus={null}
              onChoose={handleChooseStatus}
            />
            {listType === ListType.Shares && (
              <SidebarDossierFilterChoosePerson
                // users={possibleSharedBy?.data ?? []}
                onChoose={(u) => setSharedBy(u)}
                label={t("sidebar.sharedBy")}
              />
            )}
            {listType === ListType.Shares && (
              <SidebarDossierFilterChoosePerson
                // users={possibleSharedTo?.data ?? []}
                onChoose={(u) => setSharedTo(u)}
                label={t("sidebar.sharedTo")}
              />
            )}
          </div>
          <div className={styles.tagList}>
            {category !== null && (
              <Chip
                element={<>{getDossierItemCategoryLabel(category)}</>}
                onDelete={() => {
                  setCategory(null);
                }}
              />
            )}
            {tags.map((tag) => (
              <Chip
                element={<>{tag.Name}</>}
                onDelete={() => {
                  handleRemoveTag(tag);
                }}
              />
            ))}
            {statuses && (
              <div className={styles.data}>
                {statuses?.map((s) => (
                  <StatusBadge
                    onRemove={(stat) => {
                      setStatuses(statuses?.filter((a) => a.Id !== stat.Id));
                    }}
                    status={s}
                    showName
                  />
                ))}
              </div>
            )}
            {sharedBy !== null && (
              <UserBadge
                userId={sharedBy.Id}
                label={sharedBy.Label}
                allowRemove={true}
                onRemove={() => {
                  setSharedBy(null);
                }}
              />
            )}
            {sharedTo !== null && (
              <UserBadge
                userId={sharedTo.Id}
                label={sharedTo.Label}
                allowRemove={true}
                onRemove={() => {
                  setSharedTo(null);
                }}
              />
            )}
          </div>

          <div className={styles.buttonsWrapper}>
            <HollowButton text={t("common.delete")} onClick={() => handleDelete()} />
            <Button
              text={t("common.save")}
              onClick={() => handleCreate()}
              disabled={!name.length}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
